import React, { useCallback, useEffect, useState } from 'react'
import './ManageProfiles.scss'
import { ProfileTitle } from '@components/Profile/ProfileTitle/ProfileTitle'
import { VelvetSDK } from 'sdk'
import { SingularProfileCard } from '@components/Profile/SingularProfileCard/SingularProfileCard'
import { onBackKeyPress } from '@utils/helpers'
import { useNavigate } from 'react-router-dom'
import SpatialNavigation from '@utils/spatial-navigation.js'
import { AddProfileCard } from '@components/Profile/AddProfileCard/AddProfileCard'
import DotSpinner from '@components/DotSpinner/DotSpinner'
import { MAX_PROFILES_NUMBER } from '@constants/profile.const'
import { useDispatch } from 'react-redux'
import { setProfiles } from '@actions/profileActions'
import { useTypedSelector } from 'store'
import { UserProfile } from 'sdk/services/storage/profiles/types/profilesManager'
import { LocalStorageItem } from '@constants/index'
import { useUserProfiles } from '@hooks/useUserProfiles'

interface ManageProfilesProps {
  showMenu: (status: boolean) => void
}

export const ManageProfiles = ({ showMenu }: ManageProfilesProps) => {
  const V = VelvetSDK.Vocabulary.vocabulary
  const navigate = useNavigate()
  const SN = SpatialNavigation
  const [isLoading, setIsLoading] = useState(true)
  const dispatch = useDispatch()
  const profiles = useTypedSelector((state) => state.profile.profiles)
  const userObject = JSON.parse(localStorage.getItem(LocalStorageItem.USER_DATA) as string)
  const activeProfileObject = JSON.parse(localStorage.getItem(LocalStorageItem.ACTIVE_PROFILE) as string)
  const userId = userObject?.userID

  // TODO: Recheck after the edit profile screen is implemented
  const closeProfilesPage = useCallback(
    (e: KeyboardEvent) => {
      if (activeProfileObject) {
        onBackKeyPress(e, () => navigate(-1))
      }
    },
    [navigate, activeProfileObject],
  )

  useUserProfiles()

  useEffect(() => {
    document.addEventListener('keydown', closeProfilesPage)
    return () => {
      document.removeEventListener('keydown', closeProfilesPage)
    }
  }, [closeProfilesPage])

  useEffect(() => {
    const fetchProfiles = async () => {
      if (!userId) return
      try {
        const userProfiles = await VelvetSDK.Storage.Profiles.service.getProfiles(userId)
        const sortedProfiles = userProfiles.sort((a, b) => a.createdAt.seconds - b.createdAt.seconds)
        dispatch(setProfiles(sortedProfiles))
        setIsLoading(false)
      } catch (error) {
        console.error('Failed to load profiles:', error)
        setIsLoading(false)
      }
    }
    fetchProfiles()
  }, [dispatch, userId])

  useEffect(() => {
    showMenu(false)
  }, [showMenu])

  useEffect(() => {
    const firstProfileId = profiles[0]?.identifier
    SN.focus(firstProfileId)
  }, [SN, profiles])

  return (
    <div className="manage-profiles-page">
      <ProfileTitle title={V.profileManagementWhosThere} />
      <div className="user-profiles">
        {isLoading ? (
          <DotSpinner />
        ) : (
          <>
            {profiles?.map((profile: UserProfile) => (
              <SingularProfileCard key={profile.identifier} profileData={profile} setActiveProfileOnEnter />
            ))}
            {profiles?.length < MAX_PROFILES_NUMBER && <AddProfileCard />}
          </>
        )}
      </div>
    </div>
  )
}
